/* eslint-disable parog-web/no-glint-expect-error-directive */
import { concat, get } from '@ember/helper';
import { service } from '@ember/service';
import t from 'ember-intl/helpers/t';
import CrudJournalEventBaseComponent from 'parog-web/components/forc/abstract/crud-journal-event-based-component';
import type { ForcModelPojo } from 'parog-web/components/forc/abstract/journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import journalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import LinkToForc from 'parog-web/components/link-to-forc';
import IbdDiskChart from 'parog-web/components/mici/ibd-disk-chart';
import IbdDiskSurveyFilledJournalEvent from 'parog-web/models/ibd-disk-survey-filled-journal-event';
import type SemeiaSessionService from 'parog-web/services/session';

export default class extends CrudJournalEventBaseComponent<IbdDiskSurveyFilledJournalEvent> {
  static override fullComponentId = 'mici/ibd-disk-survey-consult-form';
  static override journalEventClass = IbdDiskSurveyFilledJournalEvent;

  @service declare session: SemeiaSessionService;

  override retrieveJournalEvent =
    journalEventRetrievalStrategies.sourceJournalEvent;

  override get forcDisplayName(): string {
    return this.session.medic ? 'Questionnaire IBD-Disk' : 'Qualité de vie';
  }

  get sections(): Array<string> {
    return IbdDiskSurveyFilledJournalEvent.sections;
  }

  override retrieveModel(): ForcModelPojo {
    const model = super.retrieveModel();

    this.sections.forEach(section => {
      if (!model[section]) {
        model[section] = '0';
      }
    });

    return model;
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |form|>
        <div class='fields'>
          <div class='eight wide field'>
            <form.Date
              @labelName='Date du questionnaire'
              @propertyName='occurredAt'
            />
          </div>
          <div class='eight wide field'>
            <form.Input
              @propertyName='score'
              @labelName='Score'
              {{! @glint-expect-error }}
              type='number'
              @isReadOnly={{true}}
            />
          </div>
        </div>
        <div class='field h-[250px] sm:h-[500px]'>
          <IbdDiskChart @points={{this.model.points}} />
        </div>

        <div>
          <table class='ui table'>
            <thead>
              <tr>
                <th class='ten wide'>Questions</th>
                <th class='three wide right aligned'>
                  {{#if this.session.medic}}
                    <LinkToForc
                      @feature='mici'
                      @component='ibd-disk-survey-consult-form-details'
                      @patient={{@patient}}
                      @sourceJeId={{this.model.id}}
                      data-test-edit-mici-filled-link={{this.model.id}}
                    >
                      <i class='pencil alternate primary icon'></i>
                    </LinkToForc>
                  {{else}}
                    <LinkToForc
                      @feature='mici'
                      @component='ibd-disk-survey-consult-form-details'
                      @patient={{@patient}}
                      @sourceJeId={{this.model.id}}
                      @isReadOnly={{true}}
                      data-test-read-mici-filled-link={{this.model.id}}
                    >
                      <i class='eye icon'></i>
                    </LinkToForc>
                  {{/if}}
                </th>
              </tr>
            </thead>
            <tbody>
              {{#each this.sections as |section|}}
                <tr>
                  <td>
                    <div class='flex flex-col'>
                      <div class='text-p1 text-pink'>
                        {{t (concat 'mici-form.' section '.short')}}
                        :
                      </div>
                      <div class='text-grey text-sm font-medium'>
                        {{t (concat 'mici-form.' section '.long')}}
                      </div>
                    </div>
                  </td>
                  <td class='center aligned'>
                    {{get this.model section}}/10
                  </td>
                </tr>
              {{/each}}
            </tbody>
          </table>
        </div>
      </:content>
      <:footer as |Footer|>
        <Footer.CancelButton />
      </:footer>
    </Provider>
  </template>
}
